import { utils } from "./utils"

// return authorization header with password token
export function authFileHeader() {
    let token = utils.getPasswordToken()
    let headers = {
        Authorization: "Bearer " + token,
        Accept: "application/json",
    }

    if (utils.getStore("institutionId")) {
        headers["X-Institution"] = utils.getStore("institutionId")
    }

    return headers
}
